import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { MaterialTaskData, Task } from 'entities/task'
import { TaskMasterSetKind } from 'entities/task_master_set'
import { MaterialTaskSetData } from 'entities/task_set'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateTimeText } from 'utils/util'

export const taskColumnInfoList = (form?: Form<Record<string, unknown>>, kind?: TaskMasterSetKind): ColumnInfoList => {
    const values: ColumnInfo[] = [
        { name: 'ID', th: true, width: 50, form: form, orderAttr: 'task_id', searchType: { name: 'id', type: 'multiple_text' } },
        { name: '完了日時', th: true, width: 120, form: form, orderAttr: 'task_completed_at', searchType: { name: 'completed_at', type: 'date' } },
        { name: '担当者', th: true, width: 120, form: form, orderAttr: 'task_complete_user_id' },
        { name: 'タスク', th: true, minWidth: 200, form: form, orderAttr: 'task_title', searchType: { name: 'title', type: 'text' } },
    ]

    if (kind === 'MATERIAL') {
        values.splice(
            3,
            1,
            { name: '資材', th: true, width: 150 },
            { name: '部数', th: true, width: 60, align: 'center' },
            { name: '施設名', th: true, minWidth: 200 }
        )
    }
    return {
        tableName: '',
        values: values,
    }
}

export type TaskTableDataProps = {
    task?: Task
    displaySetting: DisplaySetting
}

export const TaskTableData = ({ task, displaySetting }: TaskTableDataProps): JSX.Element => {
    if (!task) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{task.id}</TableCell>
                <TableCell>{toDateTimeText(task.completedAt)}</TableCell>
                <TableCell>{task.completeUser?.fullName}</TableCell>
                {task.taskSet?.kind === 'MATERIAL' ? (
                    (() => {
                        const data: MaterialTaskData = JSON.parse(task.data || '{}')
                        const taskSetData: MaterialTaskSetData = JSON.parse(task.taskSet?.data || '{}')
                        return (
                            <>
                                <TableCell>{data.material_name}</TableCell>
                                <TableCell align="center" unit="部">
                                    {data.number}
                                </TableCell>
                                <TableCell>{taskSetData.institution_name}</TableCell>
                            </>
                        )
                    })()
                ) : (
                    <TableCell>{task.title}</TableCell>
                )}
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
